export const manageConstants = {
  LOAD_REQUEST: 'MANAGE_LOAD_REQUEST',
  LOAD_SUCCESS: 'MANAGE_LOAD_SUCCESS',
  LOAD_FAILURE: 'MANAGE_LOAD_FAILURE',

  CHECK_INVITE_REQUEST: 'CHECK_INVITE_REQUEST',
  WAIT_INVITE_REQUEST: 'WAIT_INVITE_REQUEST',

  UPDATE_INVITE_REQUEST: 'MANAGE_INVITE_REQUEST',
  UPDATE_INVITE_SUCCESS: 'MANAGE_INVITE_SUCCESS',
  UPDATE_INVITE_FAILURE: 'MANAGE_INVITE_FAILURE',

  UPDATE_DROP_REQUEST: 'MANAGE_DROP_REQUEST',
  UPDATE_DROP_SUCCESS: 'MANAGE_DROP_SUCCESS',
  UPDATE_DROP_FAILURE: 'MANAGE_DROP_FAILURE',

  SEND_INVITE_REQUEST: 'SEND_INVITE_REQUEST',
  SEND_INVITE_SUCCESS: 'SEND_INVITE_SUCCESS',
  SEND_INVITE_FAILURE: 'SEND_INVITE_FAILURE',

  CHECK_WAIT_REQUEST: 'CHECK_WAIT_REQUEST',

  LOAD_GROUP_REQUEST: 'LOAD_GROUP_REQUEST',
  LOAD_GROUP_SUCCESS: 'LOAD_GROUP_SUCCESS',
  LOAD_GROUP_FAILURE: 'LOAD_GROUP_FAILURE',

  UPDATE_GROUP_REQUEST: 'UPDATE_GROUP_REQUEST',
  UPDATE_GROUP_SUCCESS: 'UPDATE_GROUP_SUCCESS',
  UPDATE_GROUP_FAILURE: 'UPDATE_GROUP_FAILURE',

  GET_PERMISSION_REQUEST: 'MANAGE_GET_PERMISSION_REQUEST',
  GET_PERMISSION_SUCCESS: 'MANAGE_GET_PERMISSION_SUCCESS',
  GET_PERMISSION_FAILURE: 'MANAGE_GET_PERMISSION_FAILURE',

  GET_DELEGATE_LIST_REQUEST: 'MANAGE_DELEGATE_LIST_REQUEST',
  GET_DELEGATE_LIST_SUCCESS: 'MANAGE_DELEGATE_LIST_SUCCESS',
  GET_DELEGATE_LIST_FAILURE: 'MANAGE_DELEGATE_LIST_FAILURE',

  DELEGATE_PERMISSION_REQUEST: 'MANAGE_DELEGATE_PERMISSION_REQUEST',
  DELEGATE_PERMISSION_SUCCESS: 'MANAGE_DELEGATE_PERMISSION_SUCCESS',
  DELEGATE_PERMISSION_FAILURE: 'MANAGE_DELEGATE_PERMISSION_FAILURE',

  CANCEL_DELEGATE_REQUEST: 'MANAGE_CANCEL_DELEGATE_REQUEST',
  CANCEL_DELEGATE_SUCCESS: 'MANAGE_CANCEL_DELEGATE_SUCCESS',
  CANCEL_DELEGATE_FAILURE: 'MANAGE_CANCEL_DELEGATE_FAILURE',

  RESET_DELEGATE: 'MANAGE_RESET_DELEGATE',

  // 주소변경
  CHANGE_ADDRESS: 'CHANGE_ADDRESS',
}
